import React from 'react';
import styled from 'styled-components';
import { FlexMiddle, MultipleOutsourceBadges, ApproveIcon } from '@ubeya/shared-web/components';

const Wrapper = styled(FlexMiddle)`
  cursor: default;
  .read-only {
    display: none;
  }
`;

const OutsourceBadgeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 2px 10px;
`;

const ApproveButton = styled(ApproveIcon)`
  width: 15px;
  left: 5%;
  top: 7px;
  position: absolute;
`;

const LockedTimesheetRenderer = ({ rowData }) => {
  const { summarized, subRows, isExternal, isLocked, supplierData, originSupplierData } = rowData;

  if (summarized || subRows || !isExternal || !isLocked) {
    return <></>;
  }

  return (
    <Wrapper>
      <OutsourceBadgeWrapper>
        <MultipleOutsourceBadges supplierData={supplierData} originSupplierData={originSupplierData} withName={false} />
        <ApproveButton $isActive={true} />
      </OutsourceBadgeWrapper>
    </Wrapper>
  );
};

export default LockedTimesheetRenderer;
